export const OPEN_COMPANY_MODAL = "OPEN_COMPANY_MODAL";



// WEBPACK FOOTER //
// ./src/constants/tables.js